

import { useState, useEffect } from "react";
import Config from "../../Config";

import check from "../../check.png";
import edit from "../../edit.png";


 

import DirectorNew from "./DirectorNew";
import DirectorEdit from "./DirectorEdit";

import PlTitle from "../../elements/PlTitle";
import MenuTable from "../../helpers/MenuTable";


function Directors(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);

    const [isRoot, setIsRoot] = useState(-1);


    const [view, setView] = useState( {  v:"normal", id:""  });


   


    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,directors', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status == 'ERROR'&& res.param=='No access' )
                    {
                        props.mainView.showDialog( "Ups!", "Brak wymaganych uprawnień do tej cześci strony." , "ok" , null); 
                    }else 
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

  

    const checkRoot = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,check_root', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setIsRoot(res.result);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const changeView = (e) => {

          var v = e.target.getAttribute("v");
          var id = e.target.getAttribute("id");

          setView(  {...view, ["v"]:v, ["id"]:id } );
      
    }

    const back = () => {
        setView(  {...view, ["v"]:"normal", ["id"]:"" } );
        getData();
    }


 
    if(isRoot == -1)
        {
            setIsRoot(-2);
            checkRoot();
            return (
                <div></div>
            );        
        }


    if(tab == null)
    {
        setTab([]);
        getData(); 
        return (
            <div></div>
        );        
    }

    if(tab._sys_ == undefined) //no correct response..
    {
        return (
            <div></div>
        );   
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        getData();
    }
 

 


    if(view.v == "new")
    {      
            return <DirectorNew  userData={props.userData} mainView={props.mainView}  isRoot={isRoot}  back={back}  />
    }

    if(view.v == "edit")
    {      
            var row = [];

            for(var k=0; k<tab.result.length; k++)
            {
                if(tab.result[k].id == view.id)
                {
                    row = tab.result[k];
                }
            }

            return <DirectorEdit  userData={props.userData} mainView={props.mainView}  isRoot={isRoot}  back={back} row={row} />
    }




    return (
        <div className="view_content">
     
            <div className="bg_center">
                

                    <div className="table_widget">
                    <div className="btn" onClick={changeView} v="new" id="-1"  > nowe konto dyrektora</div>
                    </div>
 


                    <table className="table">
                        <thead>
                            <tr className="header">
                                <td className="td_left">LP</td>
                                <td>Nazwisko, imię</td>
                                <td>E-mail / Login</td>
                                <td>Telefon</td>
                                <td>*ADMIN</td>
                                <td>Konto aktywne</td>
                                <td>Autoryzacja 2FA</td>
                                <td className="td_right">Przypisany / Dostęp do </td>
                                <td className="td_option"> </td>
                            </tr>
                        </thead>
                        <tbody>
                         

                            {
                                tab.result.map(  (item, ix) => {

                                var ac = '-';
                                if(item.is_active == '1') ac = <img src={check}  />

                                var fa = '-';
                                if(item.auth_f2 == '1') fa = <img src={check}  />

                                var adm = '-';
                                if(item.pl_wlasciciel == '1') adm = <img src={check}  />


                                var rowStyle = " row ";
                                if(ix % 2 == 0 )rowStyle = " row2 ";

                                 return (
                                        <tr className={rowStyle}>
                                            <td className="gocenter">{ (ix + 1) }</td>
                                            <td className="link_normal"  onClick={changeView} v="edit" id={item.id} >{item.nazwisko  + " " + item.imie }</td>
                                            <td className="gocenter">{item.e_mail_kontakt}</td>
                                            <td className="gocenter">{item.telefon_kontaktowy}</td>
                                            <td className="gocenter">{adm}</td>
                                            <td className="gocenter">{ac}</td>
                                            <td className="gocenter">{ac}</td>
                                            <td>
                                                <ul>
                                                {
                                                    item.dostepy.map( (d, i) => {

                                                        if(d.dostep == 0) return null;

                                                        return <li>
                                                                {d.nazwa}
                                                        </li>
                                                    } )
                                                }
                                                </ul>
                                            </td>
                                            <MenuTable>
                                                <ul>
                                                    <li onClick={changeView} v="edit" id={item.id} >zmień dane</li>
                                                </ul>
                                            </MenuTable>
                                            
                                        </tr>
                                        )
                                } )
                            }

                        </tbody>
                    </table>


                    <div>
                    <br/>
                       *Konto o najwyższym poziomie uprawnień. Osoba, która zarejestrowała konto na platformie eLizak.edu.pl i ma dostępem do wszystkich zakładek. 
                    </div>
            </div>
       </div>
    )
}



export default Directors;